module.exports = __webpack_public_path__ + "static/ramiro-598a4120363335b0cfcd4c6fd3453fe5.jpg";